module.exports = __webpack_public_path__ + "static/media/pattern-blue.05a3922f.svg";